<template>
  <div class="p-config-candidates">
    <LoadingChara v-if="isLoading" variant="inline" size="sm">
      <template slot="title">
        データ取得中
      </template>
    </LoadingChara>
    <Error v-else-if="hasError" variant="inline" size="sm">
      <template slot="title">
        閲覧可能なサイトがありません。
      </template>
    </Error>
    <div v-else class="p-config-candidates__inner">
      <ListProjectCandidates
        type="select"
        :checked="checked"
        :input="input"
        :items="items"
        @change="change"
      />
      <ListProjectCandidates
        v-if="input === 'checkbox'"
        type="selected"
        :checked="checked"
        :input="input"
        :items="items"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import Error from '@/components/Error';
import ListProjectCandidates from '@/components/config/ListProjectCandidates';
import LoadingChara from '@/components/LoadingChara';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Array, String],
      required: true
    },
    input: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Error,
    ListProjectCandidates,
    LoadingChara
  },
  computed: {
    hasError() {
      return !this.items.length;
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
